<script lang="ts">
  export let className: string
</script>

<svg
  class={className}
  stroke="currentColor"
  fill="currentColor"
  stroke-width="0"
  version="1.1"
  viewBox="0 0 16 16"
  height="1em"
  width="1em"
  xmlns="http://www.w3.org/2000/svg"
  ><path
    d="M14.5 0h-13c-0.825 0-1.5 0.675-1.5 1.5v13c0 0.825 0.675 1.5 1.5 1.5h13c0.825 0 1.5-0.675 1.5-1.5v-13c0-0.825-0.675-1.5-1.5-1.5zM6 13h-2v-7h2v7zM5 5c-0.553 0-1-0.447-1-1s0.447-1 1-1c0.553 0 1 0.447 1 1s-0.447 1-1 1zM13 13h-2v-4c0-0.553-0.447-1-1-1s-1 0.447-1 1v4h-2v-7h2v1.241c0.412-0.566 1.044-1.241 1.75-1.241 1.244 0 2.25 1.119 2.25 2.5v4.5z"
  ></path></svg
>
